import { Maintenance } from "./models/maintenance";

export const maintenanceService = (() => {
    const endpoint = '/frontends/mfe-manifest.json';
    const maintenanceData: Maintenance = {
        isOlbInMaintenance: false,
        isNonOlbInMaintenance: false,
        nonOlbFragments: [],
        maintenanceFragment: ''
    };

    (window as any).ipb.maintenanceData = null;

    async function getMaintenanceData(loadStaticData: boolean = false): Promise<Maintenance> {
        if(!loadStaticData) {
            return maintenanceData;
        }
        try {
            const response = await fetch(endpoint);
            if (!response.ok) {
                return maintenanceData;
            }
            const data = await response.json();
            return data as Maintenance;
        }
        catch(e) {
            return maintenanceData;
        }
    }

    return {
        async getDetails(loadStaticData: boolean = false): Promise<Maintenance> {
            if (!(window as any).ipb.maintenanceData) {
                const response = await getMaintenanceData(loadStaticData);
                (window as any).ipb.maintenanceData = response;
            }
            return (window as any).ipb.maintenanceData;
        }
    };
})();
